module.exports = __webpack_public_path__ + "static/media/shield-slash.310ef273.svg";